
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React from 'react'
import { Card, Typography } from 'antd'
import { getInfoPageWithSlug } from '../../services/cms'
import { RichText } from 'prismic-reactjs'
import Head from 'next/head'
import Wrapper, { Content } from './contracts.style'

const { Title } = Typography

function Contracts({ post }) {
  return (
    <Wrapper>
      <Head>
        <title>{post.title[0].text}</title>
      </Head>
      <Card style={{ width: '100%', maxWidth: '876px' }}>
        <Title style={{ fontSize: 38, fontWeight: 'bold' }}>{post.title[0].text}</Title>
        <div style={{ marginBottom: '1em' }}></div>
        <Content>
          <RichText render={post.content} />
        </Content>
      </Card>
    </Wrapper>
  )
}

 async function _getServerSideProps(context) {
  let { slug } = context.query

  if (context.locale == 'en') {
    if (slug === 'hakkimizda') {
      slug = 'about-us'
    } else if (slug === 'mesafeli-satis-sozlesmesi') {
      slug = 'distance-sales-agreement'
    } else if (slug === 'gizlilik-politikasi') {
      slug = 'privacy-policy'
    } else if (slug === 'kullanici-sozlesmesi') {
      slug = 'user-agreement'
    } else if (slug === 'satis-iade-ve-degisim') {
      slug = 'sales-returns-and-exchanges-conditions'
    }
  } else {
    if (slug === 'about-us') {
      slug = 'hakkimizda'
    } else if (slug === 'distance-sales-agreement ') {
      slug = 'mesafeli-satis-sozlesmesi'
    } else if (slug === 'privacy-policy') {
      slug = 'gizlilik-politikasi'
    } else if (slug === 'user-agreement ') {
      slug = 'kullanici-sozlesmesi'
    } else if (slug === 'sales-returns-and-exchanges-conditions') {
      slug = 'satis-iade-ve-degisim'
    }
  }
  let post = await getInfoPageWithSlug(slug, context.locale)
  return {
    props: { post },
  }
}

export default Contracts


    export async function getServerSideProps(ctx) {
        let res = _getServerSideProps(ctx)
        if(typeof res.then === 'function') res = await res
        return {
          ...res,
          props: {
            ...(res.props || {}),
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/p/[slug]',
              loaderName: 'getServerSideProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  